module.exports = __webpack_public_path__ + "img/sl-header-logo-syariah.34670494.png";